import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { rejoinMapImages as t } from "./rejoinMapImages.mjs";
import { useQuery as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
//#region src/properties/useSearchSuggestQuery.ts
var i = (i) => {
	let a = i.trim();
	return n({
		queryKey: e.searchSuggest(a),
		queryFn: async () => {
			let e = await r.getSearchSuggest(a);
			return {
				...e,
				properties: e.properties.map((n) => t(n, e.imageBase))
			};
		},
		enabled: a.length >= 3,
		placeholderData: (e) => e
	});
};
//#endregion
export { i as useSearchSuggestQuery };
